module.exports = __webpack_public_path__ + "static/media/lcs_xj.3471b99a.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/lcs_xj.png
// module id = 1797
// module chunks = 0 1